/**
 * Get the user role from localStorage
 * @returns {string|null} The user role ("company" or "team_member") or null if not found
 */
export function getUserRole() {
  try {
    return localStorage.getItem("user_role");
  } catch (error) {
    console.error("Error getting user role:", error);
    return null;
  }
}

/**
 * Get the user permissions array from localStorage
 * @returns {string[]} Array of permission slugs, empty array if not found or invalid
 */
export function getUserPermissions() {
  try {
    const permissionsStr = localStorage.getItem("user_permissions");
    if (!permissionsStr) {
      return [];
    }
    const permissions = JSON.parse(permissionsStr);
    return Array.isArray(permissions) ? permissions : [];
  } catch (error) {
    console.error("Error getting user permissions:", error);
    return [];
  }
}

/**
 * Check if the user can access a resource based on the required permission(s)
 * @param {string|string[]|undefined} requiredPermission - The permission slug(s) required, or undefined for no permission. 
 * If an array is provided, returns true if the user has AT LEAST ONE of the permissions.
 * @returns {boolean} True if access is allowed, false otherwise
 */
export function canAccess(requiredPermission) {
  // If no permission required, always allow access
  if (!requiredPermission) {
    return true;
  }

  const role = getUserRole();

  // If role is "company", grant full access
  if (role === "company") {
    return true;
  }

  // For team_member, check if they have the required permission
  const permissions = getUserPermissions();

  if (Array.isArray(requiredPermission)) {
    return requiredPermission.some(p => permissions.includes(p));
  }

  return permissions.includes(requiredPermission);
}

